import Styled from 'styled-components';

const StyledPixleeReviewWidget = Styled.div`
  margin: 32px;
  margin-top: ${(props) => (props.isPDPRedesignEnabled ? `0` : `32px`)};
  .tt-c-review-toolbar {
    justify-content: flex-start;

    .tt-c-review-toolbar__icon {
      height: 1.5rem;
      width: 1.5rem;
    }

    .tt-c-review-toolbar__content--right {
      margin-left: 1rem;
  }
}
`;

export default StyledPixleeReviewWidget;
